/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowFigureACircleDownIcon20Solid = forwardRef('ArrowFigureACircleDownIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 18a8 8 0 1 1 0-16 8 8 0 0 1 0 16Zm0-12.9a.9.9 0 0 1 .9.9v6.006l1.536-1.693a.9.9 0 1 1 1.333 1.21l-2.362 2.602a1.9 1.9 0 0 1-2.814 0L6.23 11.523a.9.9 0 1 1 1.333-1.21L9.1 12.006V6a.9.9 0 0 1 .9-.9Z" })));
});
